import React from "react";
import { Route, Routes } from "react-router-dom";
import LayoutConfig from "./Configuration/LayoutConfig";
import LayoutRevenue from "./RevenueManagement/LayoutRevenueManagement";
import LayoutDashboard from "./Dashboard/LayoutDashboard";
import LayoutCRM from "./CRM/LayoutCRM";
import HeaderCalendar from "./Header/HeaderCalendar";
import LayoutOperation from "./Operation/LayoutOperation";
import { API_URL } from "../utils/apiRoutes";
import LayoutRmCopilot from "./RmCopilot/LayoutRmCopilot";
import LayoutRateshop from "./Rateshop/LayoutRateshop";
import LayoutRateDistribution from "./RateDistributionModule/LayoutRateDistribution";

function Layout() {

    return (
        <>
            <Routes>
                <Route path="/dashboard" element={<LayoutDashboard />} />
                <Route path="/configuration/*" element={<LayoutConfig />} />
                <Route path="/operation/*" element={<LayoutOperation />} />
                <Route path="/revenue/*" element={<LayoutRevenue />} />
                <Route path="/crm/*" element={<LayoutCRM />} />
                <Route path="/header-events" element={<HeaderCalendar />} />
                <Route path="/RmCopilot/*" element={<LayoutRmCopilot />} />
                <Route path="/rateshop/*" element={<LayoutRateshop />} />
                <Route path="/ratedistribution/*" element={<LayoutRateDistribution />} />
            </Routes>
        </>
    );
}

export default Layout;
